import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import EditViewBuyer from "./EditViewBuyer";
import ViewBuyer from "../../../../Create/Event/ViewBuyerLots/ViewBuyer";
import EditViewLots from "./EditViewLots";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function EditViewBuyerLots(eventEditId) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setTimeout(() => {
      setValue(newValue);
    }, 1000);
  };

  return (
    <Box className="viewBuyer" sx={{ width: "100%" }}>
      <Box sx={{ borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            label="View by Buyer"
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              textTransform: "capitalize",
            }}
            {...a11yProps(0)}
          />
          <Tab
            label="View by lots"
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              textTransform: "capitalize",
            }}
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <EditViewBuyer eventEditId={eventEditId} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <EditViewLots eventEditId={eventEditId} />
      </TabPanel>
    </Box>
  );
}
